module.exports = __webpack_public_path__ + "img/mtt_1.3.0b94cc32.png";